import ReactLoading, { LoadingProps } from 'react-loading';
import { mppColorBrandPrimaryMedium } from '@pu/mpp-design-tokens/build/web/theme-diadia/tokens';

import './loading.scss';

export const Loading = ({ color = mppColorBrandPrimaryMedium, type = 'spin', ...props }: LoadingProps) => (
  <div className="mpp-loading">
    <ReactLoading type={type} color={color} {...props} />
  </div>
);
